import {
  Button,
  Checkbox,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  TextInput,
  Alert,
} from "flowbite-react";
import { useEffect, useState } from "react";
import { SquareX } from "lucide-react";
import axiosInstance from "../config/config";

export function ModalFrom({ closeModal, e_id, fetchClients }) {
  const [openModal, setOpenModal] = useState(true);
  const [tp, setTp] = useState("");
  const [c_name, setCName] = useState("");
  const [note, setNote] = useState("");
  const [t_color, setTColor] = useState("failure");
  const [msg, setMsg] = useState("");
  const [adis, setAdis] = useState(false);
  const [msg_n, setMsg_n] = useState("");

  useEffect(()=>{
    const fetchEditClients = async (id) => {
    try {
      const response = await axiosInstance.post("", {
        SysID: `select * from dbo.job_client where id=${id};`,
      });

      setCName(response.data[0].c_name);
      setTp(response.data[0].tp);
      setNote(response.data[0].note);
      console.log("Clients loaded:", response.data);
    } catch (error) {
      console.error("Error fetching clients:", error);
    }
  };
    if(e_id){
      console.log("this is Eid key: ", e_id);
      fetchEditClients(e_id);
    }
  },[e_id]);

  const alertShow = () => {
    setAdis(true);
  };
  const alertHide = () => {
    setAdis(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (c_name == "") {
      setTColor("failure");
      setMsg_n("Error!");
      setMsg("Name required!");
      alertShow();
      setTimeout(() => alertHide(), 3000);
      return;
    }

    try {
      var response;
      if(e_id) {
      response = await axiosInstance.post("", {
        SysID: `EXEC dbo.up_client @id = ${e_id}, @c_name = '${c_name}', @tp = '${tp}', @note = '${note}';`,
      });
      setMsg("Edited!");
      }else{
       response = await axiosInstance.post("", {
        SysID: `EXEC dbo.add_job_client @c_name = '${c_name}', @tp = '${tp}', @note = '${note}';`,
      });
      setMsg("Saved!");
      }

      console.log(response.data);
      setTColor("green");
      setMsg_n("Success!");
      
      alertShow();
      setTimeout(() => alertHide(), 3000);
      setCName("");
      setTp("");
      setNote("");
      fetchClients();
    } catch (error) {
      console.error("Error fetching bills:", error);
    }
  };

  return (
    <>
      <Modal show={openModal} size="md" onClose={closeModal} popup>
        <ModalHeader />
        <ModalBody>
          <div className="space-y-6">
            <div className="flex">
              <h3 className="text-xl font-medium text-gray-900 dark:text-white">
                Add Client
              </h3>
              <SquareX
                onClick={closeModal}
                className="ml-auto text-red-600 hover:cursor-pointer"
              />
            </div>
            <div>
              <div className="mb-2 block">
                <Label htmlFor="name">Client Name</Label>
              </div>
              <TextInput
                id="name"
                value={c_name}
                onChange={(event) => setCName(event.target.value)}
                required
              />
            </div>
            <div>
              <div className="mb-2 block">
                <Label htmlFor="tp">tp</Label>
              </div>
              <TextInput
                id="tp"
                value={tp}
                onChange={(event) => setTp(event.target.value)}
              />
            </div>
            <div>
              <div className="mb-2 block">
                <Label htmlFor="note">Note</Label>
              </div>
              <TextInput
                id="note"
                value={note}
                onChange={(event) => setNote(event.target.value)}
              />
            </div>
            <div className="w-full flex px-8">
              <Button
                onClick={() => {
                  setTp("");
                  setCName("");
                  setNote("");
                }}
              >
                Clear
              </Button>
              <Button onClick={(e) => handleSubmit(e)} className="ml-auto">
                Add
              </Button>
            </div>
          </div>
        </ModalBody>
        {adis && (
          <Alert className="absolute right-0 top-12" color={t_color}>
            <span className="font-medium">{msg_n}</span> {msg}
          </Alert>
        )}
      </Modal>
    </>
  );
}
